import { AppName, type HomePageViewModel } from "src/http/types";
import { usePageModelData } from "src/shared/context/PageModelDataContext";

/*
 * WARNING - DO NOT MOVE THIS FILE
 * This file location is important to ensure our linting enforces we avoid unsafely accessing page model data
 * across different applications and shared components within this repo.
 */

/**
 * Returns the page model data specifically for the home page.
 */
export const useHomePageModelData = (): HomePageViewModel => {
  const data = usePageModelData();
  if (data.appName !== AppName.Home) {
    throw new Error("useHomePageModelData must be used on the home page only");
  }
  return data;
};
